var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgsLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: none;\n      }\n\n      .st3 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 371.03,
    y1: 183.38,
    x2: 419.28,
    y2: 304.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff9f05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa603"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 521.01,
    y1: 229.28,
    x2: 640.24,
    y2: 372.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2762c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2876d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2a94e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2ca9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2db6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ebbf9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 307.2,
    y1: 443.87,
    x2: 633.97,
    y2: 374.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f01aa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#e31ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#d31ac1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ce1ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d215c0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 357.36,
    y1: 433.01,
    x2: 739.39,
    y2: 469.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#431d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#401c93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#391984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e166b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b1563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 594.27,
    y1: 463,
    x2: 709.88,
    y2: 504.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#008cce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#126cb4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M538.61,173.67l-45.55,77.22-51.45,87.21c-82.45,26.25-135.86,87.1-141.86,96.49L497.11,104l41.5,69.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M690.12,427.99c-2.79-3.28-5.69-6.36-8.68-9.25,0,0,0-.01-.01-.02-.65-1.33-40.46-81.64-142.82-91.63l-45.55-76.2,45.55-77.22,151.51,254.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M681.43,418.72c-56.16-54.53-143.3-44.25-143.3-44.25-140.59,12.94-181.7,137.53-181.7,137.53h-102.89l46.02-77.1c.06-.1.12-.2.19-.31,6-9.39,59.41-70.24,141.86-96.49,21.66-6.9,45.32-11.41,70.65-11.97,9.21-.2,17.99.14,26.35.96,102.36,9.99,142.17,90.3,142.82,91.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M740.17,512h-9.7c-58.89-59.57-142.21-84-142.21-84-110.55-27.57-172.85,25.53-189.19,39.83-16.34,14.3-42.64,44.17-42.64,44.17,0,0,41.11-124.59,181.7-137.53,0,0,87.14-10.28,143.3,44.25.01.01.01.02.01.02,2.99,2.89,5.89,5.97,8.68,9.25h.01s50.04,84.01,50.04,84.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M730.47,512h-92.08l-50.13-84s83.32,24.43,142.21,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M538.61,327.09c-8.36-.82-17.14-1.16-26.35-.96-25.33.56-48.99,5.07-70.65,11.97l51.45-87.21,45.55,76.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M110.29,757.93l84.16-189.15h43.3l84.97,189.15h-46l-69.55-166.99h17.59l-69.55,166.99h-44.92ZM152.78,717.4l11.1-33.24h97.96l11.37,33.24h-120.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.48,757.93v-189.15h82c16.96,0,31.57,2.75,43.84,8.24,12.27,5.5,21.74,13.38,28.41,23.64,6.67,10.27,10.01,22.43,10.01,36.48s-3.34,26.44-10.01,36.61c-6.68,10.18-16.15,18.06-28.41,23.64-12.27,5.58-26.88,8.38-43.84,8.38h-57.91l20.03-19.73v71.88h-44.11ZM386.59,690.92l-20.03-20.81h55.48c13.35,0,23.45-2.88,30.31-8.65,6.85-5.76,10.28-13.87,10.28-24.32s-3.43-18.51-10.28-24.18c-6.86-5.67-16.96-8.51-30.31-8.51h-55.48l20.03-20.81v107.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.87,757.93v-189.15h143.16v35.13h-99.59v118.9h103.11v35.13h-146.67ZM578.19,679.03v-34.32h91.2v34.32h-91.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.45,757.93l81.19-112.14v31.89l-77.67-108.9h49.52l53.85,75.66-21.11.54,53.58-76.2h47.36l-77.4,107.01v-31.34l82,113.49h-50.61l-55.75-80.25h20.03l-54.94,80.25h-50.06Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168,853.31v-47.41h19.56c6.36,0,11.35,1.5,14.96,4.5,3.61,3,5.42,7.12,5.42,12.36,0,3.48-.82,6.46-2.45,8.94s-3.97,4.4-6.99,5.76c-3.02,1.35-6.65,2.03-10.87,2.03h-14.66l3.89-3.93v17.74h-8.86ZM176.86,836.51l-3.89-4.27h14.25c3.91,0,6.85-.84,8.83-2.51,1.98-1.67,2.97-4,2.97-6.98s-.99-5.29-2.97-6.94c-1.98-1.65-4.92-2.47-8.83-2.47h-14.25l3.89-4.33v27.5ZM199.22,853.31l-12.07-17.2h9.48l12.13,17.2h-9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,853.31l21.47-47.41h8.73l21.54,47.41h-9.34l-18.41-42.73h3.54l-18.47,42.73h-9.07ZM220.97,842.34l2.45-6.91h25.7l2.39,6.91h-30.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.89,853.31v-47.41h19.63c4.23,0,7.85.67,10.87,2,3.02,1.33,5.35,3.26,6.99,5.79,1.64,2.53,2.45,5.55,2.45,9.07s-.82,6.47-2.45,8.97-3.97,4.45-6.99,5.82c-3.02,1.38-6.65,2.07-10.87,2.07h-14.66l3.89-4.06v17.74h-8.86ZM277.75,836.51l-3.89-4.34h14.25c3.91,0,6.85-.82,8.83-2.47s2.97-3.96,2.97-6.94-.99-5.29-2.97-6.94c-1.98-1.65-4.92-2.47-8.83-2.47h-14.25l3.89-4.33v27.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,853.31v-47.41h8.86v47.41h-8.86ZM325.88,832.99v-7.52h26.04v7.52h-26.04ZM351.23,853.31v-47.41h8.79v47.41h-8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.91,853.31v-47.41h8.86v47.41h-8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.74,853.99c-3.68,0-7.07-.6-10.16-1.79-3.09-1.2-5.78-2.9-8.08-5.11-2.3-2.21-4.08-4.79-5.35-7.72-1.27-2.93-1.91-6.19-1.91-9.75s.64-6.82,1.91-9.75c1.27-2.93,3.07-5.51,5.39-7.72,2.32-2.21,5.02-3.92,8.11-5.11,3.09-1.2,6.48-1.79,10.16-1.79,3.91,0,7.48.67,10.7,2,3.23,1.33,5.95,3.31,8.18,5.93l-5.73,5.35c-1.77-1.85-3.73-3.24-5.86-4.16-2.14-.92-4.43-1.39-6.88-1.39s-4.78.41-6.85,1.22c-2.07.81-3.86,1.96-5.39,3.45-1.52,1.49-2.72,3.25-3.58,5.28-.86,2.03-1.29,4.27-1.29,6.7s.43,4.67,1.29,6.71c.86,2.03,2.06,3.79,3.58,5.28,1.52,1.49,3.32,2.64,5.39,3.45,2.07.81,4.35,1.22,6.85,1.22s4.75-.46,6.88-1.39c2.14-.92,4.09-2.34,5.86-4.23l5.73,5.35c-2.23,2.62-4.95,4.6-8.18,5.96-3.23,1.35-6.82,2.03-10.77,2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.26,851.46c-3.48,1.21-10.17,3.03-17.66,3.03-9.24,0-16.18-2.28-21.2-7.02-4.47-4.19-7.04-10.35-7.04-17.23,0-14.41,11.28-25.17,29.47-25.17,6.81,0,12.14,1.39,14.65,2.56l-2.13,7.29c-3.07-1.32-6.8-2.37-12.82-2.37-11.66,0-19.45,6.61-19.45,17.05s7.36,17.48,19.05,17.48c3.84,0,6.69-.49,8.06-1.15v-11.6h-9.64v-7.16h18.71v24.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.19,853.36c-3.77,0-7.37-.51-10.79-1.53-3.43-1.02-6.17-2.33-8.24-3.94l3.1-6.58c1.93,1.43,4.32,2.63,7.17,3.58,2.85.96,5.77,1.43,8.76,1.43,2.53,0,4.58-.26,6.14-.78s2.71-1.23,3.45-2.12c.74-.89,1.1-1.9,1.1-3.03,0-1.39-.53-2.51-1.59-3.36-1.06-.85-2.42-1.52-4.1-2.02-1.68-.5-3.54-.95-5.59-1.37-2.05-.41-4.09-.92-6.14-1.53-2.05-.61-3.92-1.38-5.62-2.31-1.7-.93-3.07-2.18-4.1-3.75-1.03-1.56-1.55-3.56-1.55-5.99s.7-4.74,2.1-6.81c1.4-2.06,3.54-3.71,6.41-4.95,2.87-1.24,6.52-1.86,10.93-1.86,2.9,0,5.77.35,8.62,1.04,2.85.7,5.33,1.69,7.45,3l-2.83,6.58c-2.16-1.22-4.39-2.12-6.69-2.7-2.3-.59-4.51-.88-6.62-.88-2.44,0-4.44.28-6,.85-1.56.56-2.7,1.31-3.41,2.25-.71.93-1.07,1.97-1.07,3.09,0,1.39.52,2.51,1.55,3.36,1.03.85,2.39,1.51,4.07,1.99,1.68.48,3.55.93,5.62,1.37,2.07.43,4.12.94,6.14,1.53,2.02.59,3.88,1.35,5.59,2.28,1.7.93,3.07,2.17,4.1,3.71s1.55,3.51,1.55,5.9-.7,4.68-2.1,6.74c-1.4,2.06-3.55,3.71-6.45,4.95s-6.55,1.86-10.97,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.23,853.36c-3.72,0-7.18-.59-10.38-1.76s-5.97-2.82-8.31-4.95c-2.35-2.13-4.16-4.61-5.45-7.46-1.29-2.84-1.93-5.94-1.93-9.28s.64-6.5,1.93-9.35c1.29-2.84,3.1-5.32,5.45-7.43,2.34-2.11,5.1-3.75,8.28-4.92s6.64-1.76,10.41-1.76,7.17.58,10.35,1.73c3.17,1.15,5.92,2.78,8.24,4.89,2.32,2.11,4.13,4.59,5.41,7.46,1.29,2.87,1.93,5.99,1.93,9.38s-.64,6.5-1.93,9.35c-1.29,2.85-3.09,5.33-5.41,7.46-2.32,2.13-5.07,3.77-8.24,4.92-3.17,1.15-6.62,1.73-10.35,1.73ZM546.23,845.93c2.44,0,4.68-.39,6.72-1.17,2.05-.78,3.83-1.89,5.35-3.32s2.7-3.13,3.55-5.08c.85-1.95,1.28-4.1,1.28-6.45s-.41-4.5-1.24-6.45c-.83-1.96-2.01-3.65-3.55-5.08-1.54-1.43-3.33-2.54-5.38-3.32-2.05-.78-4.29-1.17-6.72-1.17s-4.7.39-6.79,1.17c-2.09.78-3.9,1.9-5.41,3.36-1.52,1.46-2.71,3.15-3.59,5.08-.87,1.93-1.31,4.07-1.31,6.42s.44,4.43,1.31,6.38c.87,1.95,2.07,3.66,3.59,5.11,1.52,1.46,3.32,2.57,5.41,3.36,2.09.78,4.36,1.17,6.79,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.68,852.71v-45.6h8.97v38.44h25.24v7.17h-34.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.99,853.36c-6.58,0-11.74-1.76-15.48-5.28-3.75-3.52-5.62-8.62-5.62-15.31v-25.67h8.97v25.41c0,4.69,1.07,8.1,3.21,10.23,2.14,2.13,5.16,3.19,9.07,3.19s6.92-1.06,9.04-3.19c2.11-2.13,3.17-5.54,3.17-10.23v-25.41h8.83v25.67c0,6.69-1.87,11.79-5.62,15.31-3.75,3.52-8.93,5.28-15.55,5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.62,852.71v-38.44h-16v-7.17h40.97v7.17h-16v38.44h-8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.35,852.71v-45.6h8.97v45.6h-8.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.97,853.36c-3.72,0-7.18-.59-10.38-1.76s-5.97-2.82-8.31-4.95c-2.35-2.13-4.16-4.61-5.45-7.46-1.29-2.84-1.93-5.94-1.93-9.28s.64-6.5,1.93-9.35c1.29-2.84,3.1-5.32,5.45-7.43,2.34-2.11,5.1-3.75,8.28-4.92,3.17-1.17,6.64-1.76,10.41-1.76s7.17.58,10.35,1.73c3.17,1.15,5.92,2.78,8.24,4.89,2.32,2.11,4.13,4.59,5.41,7.46,1.29,2.87,1.93,5.99,1.93,9.38s-.64,6.5-1.93,9.35c-1.29,2.85-3.09,5.33-5.41,7.46-2.32,2.13-5.07,3.77-8.24,4.92-3.17,1.15-6.62,1.73-10.35,1.73ZM761.97,845.93c2.44,0,4.68-.39,6.72-1.17,2.05-.78,3.83-1.89,5.35-3.32,1.52-1.43,2.7-3.13,3.55-5.08.85-1.95,1.28-4.1,1.28-6.45s-.41-4.5-1.24-6.45c-.83-1.96-2.01-3.65-3.55-5.08-1.54-1.43-3.33-2.54-5.38-3.32-2.05-.78-4.29-1.17-6.72-1.17s-4.7.39-6.79,1.17c-2.09.78-3.9,1.9-5.41,3.36-1.52,1.46-2.71,3.15-3.59,5.08-.87,1.93-1.31,4.07-1.31,6.42s.44,4.43,1.31,6.38c.87,1.95,2.07,3.66,3.59,5.11,1.52,1.46,3.32,2.57,5.41,3.36,2.09.78,4.36,1.17,6.79,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.42,852.71v-45.6h7.38l30.28,35.18h-3.66v-35.18h8.83v45.6h-7.38l-30.21-35.18h3.66v35.18h-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.25,853.36c-3.77,0-7.37-.51-10.79-1.53-3.43-1.02-6.17-2.33-8.24-3.94l3.1-6.58c1.93,1.43,4.32,2.63,7.17,3.58,2.85.96,5.77,1.43,8.76,1.43,2.53,0,4.57-.26,6.14-.78,1.56-.52,2.71-1.23,3.45-2.12.73-.89,1.1-1.9,1.1-3.03,0-1.39-.53-2.51-1.59-3.36-1.06-.85-2.43-1.52-4.1-2.02-1.68-.5-3.54-.95-5.59-1.37-2.05-.41-4.09-.92-6.14-1.53-2.05-.61-3.92-1.38-5.62-2.31-1.7-.93-3.07-2.18-4.1-3.75-1.03-1.56-1.55-3.56-1.55-5.99s.7-4.74,2.1-6.81c1.4-2.06,3.54-3.71,6.41-4.95,2.87-1.24,6.52-1.86,10.93-1.86,2.9,0,5.77.35,8.62,1.04,2.85.7,5.33,1.69,7.45,3l-2.83,6.58c-2.16-1.22-4.39-2.12-6.69-2.7-2.3-.59-4.51-.88-6.62-.88-2.44,0-4.44.28-6,.85-1.56.56-2.7,1.31-3.41,2.25-.71.93-1.07,1.97-1.07,3.09,0,1.39.52,2.51,1.55,3.36,1.03.85,2.39,1.51,4.07,1.99,1.68.48,3.55.93,5.62,1.37,2.07.43,4.12.94,6.14,1.53,2.02.59,3.89,1.35,5.59,2.28,1.7.93,3.07,2.17,4.1,3.71,1.03,1.54,1.55,3.51,1.55,5.9s-.7,4.68-2.1,6.74c-1.4,2.06-3.55,3.71-6.45,4.95-2.9,1.24-6.55,1.86-10.97,1.86Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgsLogoDark);
export default __webpack_public_path__ + "static/media/ags-logo-dark.07096159cf09fb54497ba68d419fbed2.svg";
export { ForwardRef as ReactComponent };